<template>
    <akri-works-list-component
    @monthChanged="onMonthChanged($event)"
    :default-month-id="state.monthId"
    />
    {{ state.monthId }}
</template>

<script>

export default {
    name: 'arki-technical-task-view'
};
</script>

<script setup>
    import { ref } from 'vue';

    import AkriWorksListComponent from '@/views/arki/views/document/components/akri-works-list-component.vue';

    const state = ref({monthId: 5});

    const onMonthChanged = (e) => {
        state.value.monthId = e.monthId;
        console.log(e);
    }

</script>

<style scoped>

</style>
